<template>
  <div class="container mt-3">
    <b-form-input placeholder="Search" v-model.trim="keyText"></b-form-input>
    <b-table
      hover
      responsive
      :items="cacheFilter"
      :fields="fields"
      head-variant="light"
      class="border rounded mt-3"
      :per-page="perPage"
      :current-page="currentPage"
    ></b-table>
    <div class="overflow-auto" style="display: flex;justify-content: flex-end;">
      <b-pagination v-model="currentPage" :total-rows="cacheFilter.length" :per-page="perPage"></b-pagination>
      <b-form-select
        v-model="perPage"
        :options="pageOptions"
        class="mb-3 ml-2"
        style="width: 100px;"
      ></b-form-select>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cache: [],
      keyText: "",
      fields: [
        {
          key: "name",
          formatter: e => {
            return e || "------not cached------";
          }
        },
        "path"
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [
        {
          text: "10/Page",
          value: 10
        },
        {
          text: "50/Page",
          value: 50
        }
      ]
    };
  },
  beforeCreate: function() {
    let _this = this;
    this.common.axios
      .get("./admin/ajax/cache")
      .then(res => {
        this.updateCache(res.data.root, "/");
      })
      .catch(err => {
        _this.cache.push({
          name: "error",
          path: err
        });
      });
  },
  methods: {
    updateCache(arr = [], path) {
      let c = this.cache;
      arr.forEach(e => {
        if (!e) {
          c.push({ name: "", path });
        } else if (typeof e === "string") {
          c.push({ name: e, path });
        } else {
          let dirname = Object.keys(e)[0];
          c.push({ name: dirname, path });
          if (!e[dirname]) c.push({ name: "", path: path + dirname + "/" });
          else this.updateCache(e[dirname], path + dirname + "/");
        }
      });
    }
  },
  computed: {
    cacheFilter() {
      if (!this.keyText) return this.cache;
      else
        return this.cache.filter(e => {
          return e.name.includes(this.keyText) || e.path.includes(this.keyText);
        });
    }
  }
};
</script>